/* prodig-rental-estimate (= 商品ページ上で動くオンライン見積もり)
   インライン範囲カレンダー + 開始/返却±トグル + 台数ステッパー + グライド価格。
   レート・即時見積上限は snippet の data-* (metaobject 由来) から読む。

   【価格ロジックの正本は assets/prodig-rental-cart.js の perUnit(days, cp)】
   ここでは metaobject 由来のレートから価格チェックポイント配列 cp を組み立てて渡すだけ。
   snippet 側で prodig-rental-cart.js を先に (defer 順で) 読み込んでいる。
   (2026-08-14 カート導入に伴い、重複していた perUnit/rawGlide/glideBetween を
    cart.js へ一本化した。 extensions/rental-estimate/assets/pricing.js (rental-estimate-app
    リポジトリ) にも同一ロジックがあるが、そちらへの反映は後回し = 倉智さん判断待ち)

   【metaobject キー名と実際の意味のズレ (2026-08-13 判明)】
     R.r7  (amount_7day)   = 7日      (そのまま)
     R.r14 (amount_14day)  = 14日     (そのまま。2026-08-14 新設フィールド)
     R.r3m (amount_3month) = 1か月    の月額 (!)
     R.r1y (amount_1year)  = 3ヶ月    の月額 (!)
     R.r3y (amount_3year)  = 1年      の月額 (!)
     R.r6m (amount_6month) = 6ヶ月    の月額 (2026-08-31 新設)
   変数名は既存の data-rate-* 属性名に合わせたままなので、 読むときは必ず上の表で読み替える。

   【確定ルール (倉智さん指示 2026-08-13・2026-08-14に14日区切りを追加)】
     D<7日固定 → 7日〜365日は「14日/1か月/3ヶ月/1年」総額を結ぶグライド方式 → 365日超は別途見積もり。
     台数超過(maxQty超)・期間超過(365日超)のどちらか一方でも即時計算をやめて別途見積もりにする。

   【グライド方式 (2026-08-14 頭打ち方式(min)から変更・倉智さん指示)】
   区切り(7日/14日/1か月/3ヶ月/6ヶ月/1年)の間を「差額÷日数」でなだらかに積み上げる線形補間。
   詳細・数式は prodig-rental-cart.js の perUnit() コメント参照。
   単調性 (r7≤r14≤r3m≤r1y×3≤r3y×12) が保たれている場合のみこの補間が意味を持つ (前提が崩れた
   区間はレート側の問題であり、このエンジンはクランプせず忠実に補間するだけ)。
   「次の区切り」案内 (nextTierZone/nextTierMessage、pre__nexttier 行) は 2026-08-15 に
   表示ごと廃止した (倉智さん指示。「実質1日あたり◯◯円換算」の行だけ残す)。

   【カート連携 (2026-08-14 カート方式に変更・倉智さん承認済み確定仕様)】
   - 「カートに入れる」(data-re="add-cart") : 選択内容 {handle, name, maker, start, end,
     qty, cp} を ProdigRentalCart.add() で localStorage へ追加する。 同じ機種・同じ開始日・
     同じ返却日の行は台数合算 (cart.js 側)。 追加後は ProdigRentalCart.showToast() で
     「カートに追加しました（合計N台）」+「カートを見る →」のトーストを出す
     (2026-08-15 旧・ウィジェット内インライン表示 data-re="added" から置き換え。
      気づきにくかったため画面固定のポップアップにした)。 台数超過・期間超過・
     期間未選択時は disabled。
   - 「お申し込み・お見積もり依頼はこちら →」 : /pages/contact への単純遷移 (snippet の静的リンク。
     JS は関与しない)。 ラベルは contact ページの統合ラジオ「お申し込み・お見積もり依頼」と
     完全一致させる (2026-08-14 申込/見積の2択統合に追従)。
   - 見込案件の起票は /pages/contact の送信ボタンで
     https://bms.prodig.co.jp/api/integrations/rental/inquiry へ POST する
     (assets/prodig-rental-inquiry-webhook.js)。 rental.prodig.co.jp/api は Shopify 本体なので届かない。 */
(function () {
  'use strict';
  var DAY = 86400000;
  var WD = ['日', '月', '火', '水', '木', '金', '土'];

  function pad2(x) { return (x < 10 ? '0' : '') + x; }
  function isoDate(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }

  var MAX_INSTANT_DAYS = 365; // これを超えたら即時計算せず別途見積もり (=1年超)

  // レートから5つのチェックポイント (総額) を作る。 グライドはこの5点の間を線形補間する。
  function checkpoints(R) {
    return { d7: R.r7, d14: R.r14, d30: R.r3m, d90: R.r1y * 3, d180: R.r6m * 6, d365: R.r3y * 12 };
  }

  // カート行に保存する形 (= prodig-rental-cart.js perUnit() が読む形) のチェックポイント配列。
  // [[7,総額],[14,総額],[30,総額],[90,総額],[180,総額],[365,総額]]
  function cpArray(R) {
    var cp = checkpoints(R);
    var a = [[7, cp.d7], [14, cp.d14], [30, cp.d30], [90, cp.d90]];
    if (cp.d180 > 0) a.push([180, cp.d180]);
    a.push([365, cp.d365]);
    return a;
  }

  // n を unit 単位で切り上げる (= 100円未満・10円未満の端数を出さないため。2026-08-14 倉智さん指示)。
  function ceilTo(n, unit) {
    return Math.ceil(n / unit) * unit;
  }

  function ymd(d) { return d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate(); }
  // 利用日数 = 開始日・返却日の両端含み (例: 9/10〜9/20 = 11日)。
  // 根拠 = PRODIGレンタル規約 第2条2項・3項 (2026-09-01 施行)。
  // 「レンタル物件が賃借人に到着した日を第1日として起算」「返還のため運送業者に
  // 引き渡した日をもって使用が終了」= 到着日と発送日の両方が利用期間。
  // 2026-09-01 改定: 旧約款は発送日起算・弊社着で終了だったが、他社にそろえて
  // お客様の手元にある日数に変更した。両端含みという数え方自体は変わっていない。
  // 2026-08-15 修正: 旧実装は片端カウント (+1なし) で、同じ日付選択なのに
  // カート側 (prodig-rental-cart.js lineDays = 両端含み) と日数・金額が1日ズレていた。
  // この日数がグライド計算のD・「ご利用日数」表示・実質1日あたりの分母・
  // 期間超過判定 (>365 = 両端含み366日以上で別途見積もり)・カート行の再計算すべての正。
  function rentalDays(a, b) { return Math.round((b - a) / DAY) + 1; }
  function yen(n) { return '¥' + Number(n).toLocaleString('ja-JP'); }
  function same(a, b) { return a && b && a.getTime() === b.getTime(); }

  function init(el) {
    var C = window.ProdigRentalCart; // 価格計算・カートの正本 (snippet が先に読み込み済み)
    var q = function (s) { return el.querySelector('[data-re="' + s + '"]'); };
    var n = function (k) { return parseInt(el.getAttribute('data-' + k), 10); };
    var R = { r7: n('rate-7d'), r14: n('rate-14d'), r3m: n('rate-3m'), r1y: n('rate-1y'), r3y: n('rate-3y'), r6m: n('rate-6m') };
    var CP = cpArray(R);
    // maxQty は「フィールド無し・数値でない」場合のみ既定20にフォールバックする。
    // 0 は「即時見積を常に出さない」という管理画面側の明示的な設定値になり得るため、
    // JS の `x || 20` のような書き方で 0 を無効値扱いしない (falsy トラップ回避)。
    var maxQtyRaw = n('max-qty');
    var maxQty = isNaN(maxQtyRaw) ? 20 : maxQtyRaw;
    var productName = el.getAttribute('data-product-name') || '';
    var maker = el.getAttribute('data-maker') || '';
    var handle = el.getAttribute('data-handle') || '';
    var contact = el.getAttribute('data-contact-url') || '/pages/contact'; // トーストの「カートを見る」先

    // 1台あたりの期間料金 (グライド)。 正本は prodig-rental-cart.js。
    function perUnit(d) {
      return C ? C.perUnit(d, CP) : null;
    }

    // 未設定の初期状態 (2026-08-15 倉智さん指示)。 期間・台数とも「—」で始まり、
    // 両方設定されるまで金額を出さない。 旧: 開いた瞬間に今日+3〜+13・2台が入っていた。
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var startD = null;
    var endD = null;
    var view = new Date(today.getFullYear(), today.getMonth(), 1);
    // 日付±が未設定状態で押された時の初期値 (= 開始=今日+3、返却=開始+6)。
    // 返却+6 は両端含みでちょうど7日間 = 1週間 (2026-08-15 両端含み統一に合わせて 7→6)。
    var INIT_START_OFFSET = 3;
    var INIT_END_OFFSET = 6;

    function renderCal() {
      var y = view.getFullYear(), m = view.getMonth();
      var startW = new Date(y, m, 1).getDay(), dim = new Date(y, m + 1, 0).getDate();
      var prevOff = (y === today.getFullYear() && m === today.getMonth());
      var h = '<div class="pre-cal__head">';
      h += '<button type="button" class="pre-cal__nav" data-re="prev"' + (prevOff ? ' disabled' : '') + '>‹</button>';
      h += '<div class="pre-cal__title">' + y + '年 ' + (m + 1) + '月</div>';
      h += '<button type="button" class="pre-cal__nav" data-re="next">›</button></div><div class="pre-cal__grid">';
      for (var w = 0; w < 7; w++) h += '<div class="pre-cal__wd ' + (w === 0 ? 'sun' : w === 6 ? 'sat' : '') + '">' + WD[w] + '</div>';
      for (var i = 0; i < startW; i++) h += '<div class="pre-cal__cell"></div>';
      for (var d = 1; d <= dim; d++) {
        var cur = new Date(y, m, d), past = cur < today;
        var isS = same(cur, startD), isE = same(cur, endD);
        var inR = startD && endD && cur > startD && cur < endD;
        var cls = 'pre-cal__cell' + (inR ? ' in-range' : '') + (isS && endD ? ' in-range r-start' : '') + (isE ? ' in-range r-end' : '');
        h += '<div class="' + cls + '"><button type="button" class="pre-cal__day' + ((isS || isE) ? ' sel' : '') + '"' + (past ? ' disabled' : '') + ' data-d="' + d + '">' + d + '</button></div>';
      }
      h += '</div><div class="pre-cal__hint">' + (!startD ? '貸出開始日を選んでください' : (!endD ? '返却日を選んでください' : '別の日を押すと選び直せます')) + '</div>';
      q('cal').innerHTML = h;
      q('prev').onclick = function () { if (!prevOff) { view = new Date(y, m - 1, 1); renderCal(); } };
      q('next').onclick = function () { view = new Date(y, m + 1, 1); renderCal(); };
      var days = q('cal').querySelectorAll('.pre-cal__day');
      for (var k = 0; k < days.length; k++) days[k].onclick = onPick;
    }

    function onPick(e) {
      var d = parseInt(e.currentTarget.getAttribute('data-d'), 10);
      var p = new Date(view.getFullYear(), view.getMonth(), d);
      if (!startD || (startD && endD)) { startD = p; endD = null; }
      else if (p > startD) { endD = p; }
      else { startD = p; endD = null; }
      renderCal(); recalc();
    }

    function stepDate(which, dir) {
      if (which === 'start') {
        if (!startD) {
          // 未設定状態からの最初の一押しは「今日+3」を置くだけ (dir は適用しない)
          startD = new Date(today.getFullYear(), today.getMonth(), today.getDate() + INIT_START_OFFSET);
        } else {
          var ns = new Date(startD.getTime() + dir * DAY);
          if (ns < today) ns = new Date(today.getTime());
          if (endD && ns >= endD) ns = new Date(endD.getTime() - DAY);
          startD = ns;
        }
        view = new Date(startD.getFullYear(), startD.getMonth(), 1);
      } else {
        if (!startD) return; // 開始日が無いのに返却日だけは決められない
        if (!endD) {
          // 返却側の最初の一押しは「開始+6 = 両端含み7日間」を置くだけ (dir は適用しない)
          endD = new Date(startD.getTime() + INIT_END_OFFSET * DAY);
        } else {
          var ne = new Date(endD.getTime() + dir * DAY);
          if (ne <= startD) ne = new Date(startD.getTime() + DAY);
          endD = ne;
        }
        view = new Date(endD.getFullYear(), endD.getMonth(), 1);
      }
      renderCal(); recalc();
    }

    function updateDb() {
      // 未設定でも「押したら初期値から始まる」ため、無効化は本当に操作できない場合だけにする:
      // 開始− = 開始が今日以前 (未設定なら押せる=初期値が入る) / 返却± = 開始が無い間は不可
      var sM = el.querySelector('[data-step="start"][data-dir="-1"]');
      if (sM) sM.disabled = !!startD && startD.getTime() <= today.getTime();
      var ends = el.querySelectorAll('[data-step="end"]');
      for (var i = 0; i < ends.length; i++) ends[i].disabled = !startD;
      var eM = el.querySelector('[data-step="end"][data-dir="-1"]');
      if (eM && endD && startD) eM.disabled = (endD.getTime() - startD.getTime()) <= DAY;
    }

    // 台数は空欄=未設定。 未設定で「＋」を押したら1台から開始、「−」は未設定のまま。
    function stepQty(nn) {
      var raw = (q('qty').value || '').trim();
      if (raw === '') {
        if (nn > 0) q('qty').value = 1;
      } else {
        var v = (parseInt(raw, 10) || 1) + nn;
        q('qty').value = v < 1 ? 1 : v;
      }
      recalc();
    }

    // 設定をクリアして未設定の初期状態へ戻す (2026-08-15 追加・倉智さん指示)。
    // ウィジェットの選択状態だけを消す = カートに入れた行には影響しない。
    function resetSelection() {
      startD = null;
      endD = null;
      q('qty').value = '';
      view = new Date(today.getFullYear(), today.getMonth(), 1);
      renderCal(); recalc();
    }

    // 別途見積もりの理由 (台数超過・期間超過・両方) に応じた案内文。
    // 誘導先は共通CTA「お申し込み・お見積もり依頼はこちら →」(snippet の静的リンク)。
    function quoteMessage(overQty, overPeriod) {
      if (overQty && overPeriod) {
        return {
          title: (maxQty + 1) + '台以上・1年を超えるご利用は別途お見積もりとなります',
          desc: '台数・ご利用期間のいずれも上限を超えています。下の「お申し込み・お見積もり依頼はこちら」からご相談ください。'
        };
      }
      if (overPeriod) {
        return {
          title: '1年を超えるご利用は別途お見積もりとなります',
          desc: '長期のご利用は契約条件に応じた特別料金をご提案します。下の「お申し込み・お見積もり依頼はこちら」からご相談ください。'
        };
      }
      return {
        title: (maxQty + 1) + '台以上のご利用は別途お見積もりとなります',
        desc: '大量レンタルは台数・期間に応じた特別料金をご提案します。下の「お申し込み・お見積もり依頼はこちら」からご相談ください。'
      };
    }

    // 「カートに入れる」。 選択内容を localStorage カート (prodig-rental-cart.js) へ追加し、
    // トーストで合計台数と /pages/contact への導線を出す。 disabled 制御は recalc() 側で済んでいる前提。
    function addToCart() {
      if (!C || !startD || !endD) return;
      var qty = parseInt(q('qty').value, 10) || 0;
      if (qty < 1) return;
      var list = C.add({
        handle: handle,
        name: productName,
        maker: maker,
        start: isoDate(startD),
        end: isoDate(endD),
        qty: qty,
        cp: CP
      });
      if (C.showToast) {
        C.showToast('カートに追加しました（合計' + C.totalQty(list) + '台）', {
          linkHref: contact,
          linkText: 'カートを見る →',
          // 直前の追加だけを打ち消す (新規行なら行ごと削除・合算なら合算前の台数へ。
          // cart.js undoLastAdd() 参照)。 取り消し後は文言を差し替えたトーストを出し直す
          onUndo: function () {
            var after = C.undoLastAdd();
            if (!after) return;
            C.showToast('取り消しました（合計' + C.totalQty(after) + '台）', {
              linkHref: contact,
              linkText: 'カートを見る →'
            });
          }
        });
      }
    }

    function recalc() {
      // 期間・台数の表示は未設定なら「—」(range block は常時表示)
      q('r-start').textContent = startD ? ymd(startD) : '—';
      q('r-end').textContent = endD ? ymd(endD) : '—';
      q('r-days').textContent = (startD && endD) ? (rentalDays(startD, endD) + '日間') : '—';
      updateDb();
      q('err').style.display = 'none'; q('result').style.display = 'none'; q('quote').style.display = 'none';
      var guide = q('guide');
      guide.style.display = 'none';
      var addBtn = q('add-cart');
      addBtn.disabled = true;
      // 台数: 空欄=未設定 (null)。 数値が入っていれば従来どおり検証する
      var qtyRaw = (q('qty').value || '').trim();
      var qty = qtyRaw === '' ? null : (parseInt(qtyRaw, 10) || 0);
      // 「設定をクリア」は何かひとつでも設定されている間だけ出す (未設定では消すものが無い)
      var resetRow = q('reset-row');
      if (resetRow) resetRow.style.display = (startD || endD || qty !== null) ? 'block' : 'none';
      // 未設定の間は金額を出さず、2段階の案内だけ表示する。
      // 超過判定 (台数・期間) は両方設定されてからしか動かない (= 未設定で誤発動しない)。
      if (!startD || !endD || qty === null) {
        guide.textContent = (!startD || !endD)
          ? 'カレンダーで貸出期間を選択してください'
          : '台数を選択してください';
        guide.style.display = 'block';
        return;
      }
      if (qty < 1) { q('err').textContent = '台数は1台以上を入力してください。'; q('err').style.display = 'block'; return; }
      var days = rentalDays(startD, endD);
      var overQty = qty > maxQty;
      var overPeriod = days > MAX_INSTANT_DAYS;
      if (overQty || overPeriod) {
        // 別途見積もり: カート追加は不可のまま、文言と共通CTAへの誘導だけ出す
        var msg = quoteMessage(overQty, overPeriod);
        var qTitle = q('quote-title'), qDesc = q('quote-desc');
        if (qTitle) qTitle.textContent = msg.title;
        if (qDesc) qDesc.textContent = msg.desc;
        q('quote').style.display = 'block';
        return;
      }
      var pu = perUnit(days);
      if (pu == null) return; // cart.js 未読込等 (通常起きない)。 金額なしでボタンも無効のまま
      addBtn.disabled = false;
      q('o-unit').textContent = yen(pu);
      q('o-qty').textContent = '×' + qty;
      q('o-total').textContent = yen(pu * qty);
      // 合計が主・単価が従。 「実質1日あたり◯◯円換算」は総額÷日数の参考値であって、
      // 「単価×日数=合計」ではない (= グライドで日々変わる単価の平均値でしかない)。 誤解防止のため
      // 7日未満(固定額ゾーン)は日割り換算そのものを出さない。
      var perdayEl = q('o-perday');
      if (perdayEl) {
        perdayEl.textContent = (days < 7)
          ? '1日からご利用いただけます (料金は7日分から)'
          : '実質1日あたり' + yen(ceilTo(pu / days, 10)) + '換算・' + days + '日間';
      }
      q('result').style.display = 'block';
    }

    q('qty').addEventListener('input', recalc);
    q('qplus').onclick = function () { stepQty(1); };
    q('qminus').onclick = function () { stepQty(-1); };
    var dbs = el.querySelectorAll('[data-step]');
    for (var b = 0; b < dbs.length; b++) {
      dbs[b].onclick = function (e) { stepDate(e.currentTarget.getAttribute('data-step'), parseInt(e.currentTarget.getAttribute('data-dir'), 10)); };
    }
    q('add-cart').addEventListener('click', addToCart);
    var resetBtn = q('reset');
    if (resetBtn) resetBtn.addEventListener('click', resetSelection);
    renderCal(); recalc();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var nodes = document.querySelectorAll('.prodig-rental-estimate');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  });
})();
